module.exports = __webpack_public_path__ + "static/media/certificate-400x225.1be8474a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/certificate-400x225.jpg
// module id = 687
// module chunks = 0